import SubNav from './SubNav'

class SubNavCustomer extends React.Component {
  render () {
    let {user, subscriptionExpired} = this.props
    let statusLabelNew = Cookies.get('labelNewLoyalty') === undefined || Cookies.get('labelNewLoyalty') === 'true'
    const links = [
      {
        href: '/customers/list',
        label: 'Customers List'
      },
      {
        href: '/customers/feedback_list',
        label: 'Feedback'
      },
      {
        href: '/customers/loyalty',
        label: 'Loyalty Program',
        isNew: statusLabelNew
      }
    ]

    return (<SubNav links={links} location={this.props.location} user={user} subscriptionExpired={subscriptionExpired} />)
  }
}

SubNavCustomer.propTypes = {
  location: React.PropTypes.object
}
export default SubNavCustomer



// WEBPACK FOOTER //
// ./app/components/SubNav/SubNavCustomer.js